import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { environment } from 'src/environments/environment';
 
@Component({
  selector: 'app-fee-templet-mapping-dialog-box',
  templateUrl: './fee-templet-mapping-dialog-box.component.html',
  styleUrls: ['./fee-templet-mapping-dialog-box.component.scss']
})
export class FeeTempletMappingDialogBoxComponent implements OnInit {
 
  feeMappingForm: FormGroup;
  FeetempDataSearchForm: FormGroup;
  list;
  submitButton = true;
  editButton = false;
  deleteButton = false;
  fcCodeList: any;
  showBranch = false;
  SemDrp = false;
  filteredListFcCode: any;
  courseList = [];
  filteredCourseList = [];
  sessionList: any[];
  SessionFilterList: any[];
  courseStreamList: any;
  filteredStreamList: any;
  cgList: any;
  filteredcgList: any;
  templetMapList: any;
  submitpayload: any;
  TemMappingIddd: any;
  APIService: string;
  filteredcgtypeList: any;
  cgtypeList: any;
  examList: any;
  filteredListExam: any;
  semList: any;
  filteredListSem: any;
  FacultyName: any;
  feetempArray: FormArray;
  feeCreate = true;
  isreaddelete = false;
  feeUpdate = true;
  feeDelete = true;
  userPermission: any;
  UserCollege
  utp: any;
  feeList: any;
  filteredfeeList: any;
  FeeTempletList
  filteredFeeTempletList
  value
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  loadingMoreData: boolean = false;
  collegeList: any;
  CourseWisecollegeList
  filteredCourseWisecollegeList = []
  errMsg: any;
  filteredFeeTempletList2: any;
  EmId: any;
  collegedel
  datafordel
  collegeListData = false;
  selectedColleges = [];
  commaSeparatedColleges: any;
  isSelectAll: boolean;
  SelectAllActive: boolean;
  cgValue: any;
  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private dialogRef2: MatDialogRef<FeeTempletMappingDialogBoxComponent>,
    private spinner: NgxSpinnerService) { this.APIService = environment.serviceUrl; }
  dialogRef: MatDialogRef<any>;
  ngOnInit(): void {
    window.scroll(0, 0);
    this.isSelectAll = true
    this.collegeListData = false;
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    this.list = true;
    this.SemDrp = false;
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      this.userPermission.forEach(element => {
        if (element.PageName == 'Fee Template Mapping' && element.PCreate == false) {
          this.feeCreate = false;
        }
        if (element.PageName == 'Fee Template Mapping' && element.PUpdate == false) {
          this.feeUpdate = false;
        }
        if (element.PageName == 'Fee Template Mapping' && element.PDelete == false) {
          this.feeDelete = false;
        }
      });
    }
    this.showBranch = false;
    this.feeMappingForm = this.fb.group({
      Faculty: new FormControl('', [Validators.required]),
      Course: new FormControl('', [Validators.required]),
      Colleges: new FormControl('', [Validators.required]),
      EmId: new FormControl('', [Validators.required]),
      Sem: new FormControl(''),
      Session: new FormControl('', [Validators.required]),
      Branch: new FormControl(''),
      CollegeType: new FormControl('', [Validators.required]),
      FeeType: new FormControl('', [Validators.required]),
      FeeTemplate: new FormControl('', [Validators.required]),
      FeeTemplateDup: new FormControl(''),
      // feetempArray: new FormArray([]),
    });
    this.FeetempDataSearchForm = this.fb.group({
      SearchString: new FormControl(''),
    });
    let idd = '';
    this.fetchSecretData();
    this.fetchFacultyCode();
    this.fetchSession(idd);
    this.fetchCgUni();
    this.fetchCollegeType();
    this.fetchFeeType();
    this.getClg()
    if (this.data.key == "Edit") {
      this.prepopulation(this.data.selected);
    } else if (this.data.key == "Delete") {
      this.prepopulationForDelete(this.data.selected);
    }
  }

  fetchSecretData() {
    this.spinner.show()
    this.umsService.getSecretData().subscribe((res) => {
      if(res.status){
        this.spinner.hide();
        let activeFlowObject = res.projectPharam['ActiveFlow']
        let arrActiveFlow = JSON.parse(activeFlowObject);
        if(arrActiveFlow[0]['CutOffDateAllClg'] == 1){
          this.SelectAllActive = true;
        }
        else if(arrActiveFlow[0]['CutOffDateAllClg'] == 0){
          this.SelectAllActive = false;
        }

      }
      else{
        this.spinner.hide()
      }
      // this.fetchSupExamRecord(res.projectPharam['SnNo']);
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide()
      }
    );
  }
 
  getfeetempArrayControls() {
    return (this.feeMappingForm.get('feetempArray') as FormArray).controls;
  }
 
  getCourseName(id, i) {
    this.spinner.show()
    const payload = {};
    payload['CoCode'] = id;
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.feetempArray = this.feeMappingForm.get('feetempArray') as FormArray;
        this.feetempArray.at(i).get('CourseName').setValue(res.data[0]['CoName']);
      }
      else{
        this.spinner.hide()
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }
 
  fetchSessionName(id, i) {
    this.spinner.show()
    const payload = {};
    payload['SnNo'] = id;
    this.umsService.getSession(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.feetempArray = this.feeMappingForm.get('feetempArray') as FormArray;
        this.feetempArray.at(i).get('SessionName').setValue(res.data[0]['SnName']);
      }
      else{
        this.spinner.hide()
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }
 
  fetchFacultyName(id, i) {
    this.spinner.show()
    const payload = {};
    payload['FcCode'] = id;
    this.umsService.getFaculty(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.feetempArray = this.feeMappingForm.get('feetempArray') as FormArray;
        this.feetempArray.at(i).get('FacultyName').setValue(res.data[0]['FcDesc']);
      }
      else{
        this.spinner.hide()
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }
 
  fetchFacultyCode() {
    this.spinner.show()
    const payload = {};
    this.umsService.getFaculty(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.fcCodeList = res.data;
        this.filteredListFcCode = this.fcCodeList.slice();
      }
      else{
        this.spinner.hide()
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }
 
  fetchCollegeType() {
    this.spinner.show()
    const payload = {};
    payload['CdType'] = 'CG';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.cgtypeList = res.data;
        this.filteredcgtypeList = this.cgtypeList.slice();
      } else {
        this.spinner.hide()
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }
 
  getCourseData(id) {
    this.courseList = []
    this.filteredCourseList = []
    this.spinner.show();
    const payload = {};
    this.filteredListExam = []
    this.filteredListSem = []
    this.examList = []
    this.showBranch = false;
    payload['CoFcCode'] = id;
    this.umsService.getCourse(payload).subscribe(res => {
      if(res.status){
        this.spinner.hide();
        this.courseList = res.data;
        this.filteredCourseList = this.courseList.slice();
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }
 
  getExam(e) {
    this.spinner.show();
    const payload = {};
    payload['EmCoCode'] = e.CoCode;
    this.showBranch = false;
    this.examList = [];
    this.filteredListExam = []
    this.umsService.getExam(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.examList = res.data;
        this.filteredListExam = this.examList.slice();
        // this.feeMappingForm.controls["EmId"].setValue('');
      }
      else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }
 
  getSem(e) {
    this.EmId = e.EmId
    this.SemDrp = false;
    this.showBranch = false;
    if (e.EmStreams == 'Y') {
      this.showBranch = true;
    }
    else if (e.EmStreams == 'N') {
      this.showBranch = false;
    }
    this.spinner.show();
    const payload = {};
    payload['SeEmId'] = e.EmId
    this.umsService.getExamSem(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.SemDrp = true;
        this.showBranch = true;
        this.semList = res.data;
        this.filteredListSem = this.semList.slice();
 
        // this.feeMappingForm.controls["Sem"].setValue('');
      }
      else {
        this.SemDrp = false;
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }
 
  fetchSession(id) {
    this.spinner.show()
    const payload = {};
    payload['SnDefault'] = id;
    payload['SnNo'] = id;
    this.umsService.getSession(payload).subscribe(res => {
      this.sessionList = [];
      if (res.status) {
        this.spinner.hide()
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
      else{
        this.spinner.hide()
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }
 
 
  getExamStreamData(id) {
    this.SemDrp = false;
    this.showBranch = false;
    this.spinner.show();
    const payload = {};
    payload['CoCode'] = id;
    payload['EmId'] = 0;
    this.umsService.getExamStream(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.showBranch = true;
        this.courseStreamList = res.data;
        this.filteredStreamList = this.courseStreamList.slice();
        // this.feeMappingForm.controls["Branch"].setValue('');
      }
      else {
        this.spinner.hide()
        this.showBranch = false;
      }
 
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    }
    );
  }
 
  addnewrecord(e) {
    if (e === 'true') {
      this.list = false;
      this.editButton = false;
      this.submitButton = true;
      this.deleteButton = false;
      this.showBranch = false;
      // this.isread = false;
      this.isreaddelete = false;
      this.feeMappingForm.reset();
    }
    else {
      this.list = true;
      this.editButton = true;
      this.submitButton = false;
      this.deleteButton = true;
      this.showBranch = false;
      // this.getFacultyData();
      this.ngOnInit();
    }
  }
 
  fetchCgUni() {
    this.spinner.show()
    const payload = {};
    payload['CdType'] = 'CgUni';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.cgList = res.data;
        this.filteredcgList = this.cgList.slice();
      } else {
        this.spinner.hide()
      }
    });
  }
 
  save() {
    if (this.feeMappingForm.invalid) {
      this.feeMappingForm.get('Faculty').markAsTouched();
      this.feeMappingForm.get('Course').markAsTouched();
      this.feeMappingForm.get('EmId').markAsTouched();
      this.feeMappingForm.get('Session').markAsTouched();
      this.feeMappingForm.get('CollegeType').markAsTouched();
      this.feeMappingForm.get('FeeType').markAsTouched();
      this.feeMappingForm.get('FeeTemplate').markAsTouched();
      this.feeMappingForm.get('Colleges').markAsTouched();
 
    } else {
      this.submitFeeTemMap();
      // this.deleteTemplate();
    }
  }
 
  submitFeeTemMap() {
    this.spinner.show();
    this.submitpayload = this.feeMappingForm.value;
    let iserror = false;
    // let collegeCode = this.selectedColleges.join(',');
    this.submitpayload['Colleges'] = this.commaSeparatedColleges != '' ? this.commaSeparatedColleges : '';
    
    this.umsService.addFeeTempletMapping(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.spinner.hide();
        let data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.dialogRef2.close()
        });
      }
      else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
       }
     
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
       
      });
 
  }
 
  update() {
    if (this.feeMappingForm.invalid) {
      this.feeMappingForm.get('Faculty').markAsTouched();
      this.feeMappingForm.get('Course').markAsTouched();
      this.feeMappingForm.get('EmId').markAsTouched();
      this.feeMappingForm.get('Session').markAsTouched();
      this.feeMappingForm.get('Colleges').markAsTouched();
      this.feeMappingForm.get('CollegeType').markAsTouched();
      this.feeMappingForm.get('FeeType').markAsTouched();
      this.feeMappingForm.get('FeeTemplate').markAsTouched();
    } else {
      // this.updateFeeTempletMapping();
      this.deleteupdate(this.feeMappingForm.value)
    }
  }
 
  deleteupdate(id) {
    this.spinner.show();
    
    // let collegeCode = [id.Colleges.join(',')];
    // let formattedString = id.Colleges.map(item => `'${item}'`).join(', ');
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
        Faculty: id.Faculty,
        Course: id.Course,
        EmId: id.EmId,
        Sem: id.Sem,
        Session: id.Session,
        Branch: id.Branch,
        FeeType: id.FeeType,
        CollegeType: id.CollegeType,
        FeeTemplate: id.FeeTemplateDup,
        Colleges:this.datafordel,
        TemMappingId: this.TemMappingIddd
      },
    };
    this.httpClient.delete(this.APIService + '/fees/templatemapping', options)
      .subscribe((s) => {
        this.spinner.hide();
        let cc = [];
        cc.push(s);
        if(cc[0].status == true){
          this.updateFeeTempletMapping();
          this.spinner.hide();
        }
        else if(cc[0].status == false){
          let  data = {}
          data['message'] = cc[0].message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe(result => {
            this.dialogRef2.close();
          });
        }
       
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      });
 
  }
 
  updateFeeTempletMapping() {
    this.spinner.show();
    this.submitpayload = this.feeMappingForm.value;
    let iserror = false;
    // let collegeCode = this.selectedColleges.join(',');;
    this.submitpayload['Colleges'] = this.commaSeparatedColleges != '' ? this.commaSeparatedColleges : '';
    this.submitpayload['FeeTemplateDup'] = this.submitpayload.FeeTemplate;
    this.umsService.addFeeTempletMapping(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.spinner.hide();
        let data = {}
        data['message'] = "Updated Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.dialogRef2.close()
        });
      }
      else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
             
       }
     
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      });
  }
 
  // UpdatePrevious(){
  //   this.spinner.show();
  //   this.submitpayload = this.feeMappingForm.value;
  //   let iserror = false;
  //   var bar = new Promise<void>((resolve, reject) => {
  //     this.submitpayload.Colleges.forEach((element, index, array) => {
  //       let arr1 = [];
  //       arr1.push(
  //         this.fb.group({
  //           Branch: new FormControl(this.submitpayload.Branch),
  //           CollegeType: new FormControl(this.submitpayload.CollegeType),
  //           Course: new FormControl(this.submitpayload.Course),
  //           EmId: new FormControl(this.submitpayload.EmId),
  //           Faculty: new FormControl(this.submitpayload.Faculty),
  //           FeeTemplate: new FormControl(this.submitpayload.FeeTemplateDup),
  //           FeeTemplateDup: new FormControl(this.submitpayload.FeeTemplateDup),
  //           FeeType: new FormControl(this.submitpayload.FeeType),
  //           Sem: new FormControl(this.submitpayload.Sem),
  //           Session: new FormControl(this.submitpayload.Session),
  //           Colleges: new FormControl(element),
  //         })
  //       )
  //       this.umsService.addFeeTempletMapping(arr1[0].value).subscribe(res => {
  //         this.spinner.hide();
  //         if (res.status == false) {
  //           iserror = true;
  //           this.errMsg = res.message
  //         }
  //         if (index === array.length - 1) resolve();
  //         else {
  //           iserror = false
  //           this.errMsg = res.message
  //           // this.NewCoSch();  disabled automatic course schedule api calls as discussed on 21/02/24
  //         }
  //         if (res.status == true) {
  //           iserror = false
  //           this.errMsg = res.message
  //           // this.NewCoSch();  disabled automatic course schedule api calls as discussed on 21/02/24
  //         }
  //       },
  //         (ERROR: HttpErrorResponse) => {
  //           this.spinner.hide();
  //           iserror = true;
  //           this.errMsg = ERROR.error.message
  //           if (index === array.length - 1) resolve();
  //         });
  //     });
  //   })
  //   bar.then(() => {
  //     if (iserror == false) {
  //       let data = {}
  //       data['message'] = "Record Already Exists"
  //       data['title'] = 'Alert'
  //       data['icon'] = 'fas fa-close'
  //       this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //       this.dialogRef.afterClosed().subscribe((result) => {
  //         this.dialogRef2.close()
  //       });
  //     } else {
  //         let data = {}
  //         data['message'] = this.errMsg
  //         data['title'] = 'Alert'
  //         data['icon'] = 'fas fa-close'
  //         this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //         this.ngOnInit();
  //     }
  //   });
  // }
 
  editdata(e, k) {
    if (e === 'true') {
      this.list = false;
      this.prepopulation(k);
    } else {
      this.list = true;
    }
  }
 
  prepopulation(id) {
    const payload = {};
    this.getCourseData(id.Faculty);
    payload['TemMappingId'] = id.TemMappingId;
    this.TemMappingIddd = id.TemMappingId;
    this.getFilterCourse(id.Course)
    
    this.umsService.getFeeTempletMapping(payload).subscribe((res) => {
      let data = res.data[0];
      this.datafordel = res.data[0].Colleges;
      if(this.SelectAllActive == true){
        this.cgValue = id.Colleges.split(',');
        this.commaSeparatedColleges = id.Colleges
      }
      else if(this.SelectAllActive == false){
        this.cgValue = res.data[0].Colleges;
        this.commaSeparatedColleges = res.data[0].Colleges;
      }
      if (res.data[0].Branch != ' ') {
        this.showBranch = true;
        this.getExamStreamData(data.Course);
      } else {
        this.showBranch = false;
      }
      if (res.status) {
        this.editButton = true;
        this.submitButton = false;
        this.deleteButton = false;
        this.isreaddelete = false;
        this.getFeeTempletData(data.FeeType)
        this.getCourseData(data.Faculty);
        this.getExam(data.Course)
        this.getSem(data)
        this.getFilterCourse(data.Course)
        this.feeMappingForm = this.fb.group({
          Faculty: new FormControl(data.Faculty, [Validators.required]),
          Course: new FormControl(data.Course, [Validators.required]),
          EmId: new FormControl(data.EmId, [Validators.required]),
          Sem: new FormControl(data.Sem),
          Session: new FormControl(data.Session, [Validators.required]),
          Branch: new FormControl(data.Branch),
          CollegeType: new FormControl(data.CollegeType, [Validators.required]),
          FeeType: new FormControl(data.FeeType, [Validators.required]),
          FeeTemplate: new FormControl(data.FeeTemplate, [Validators.required]),
          FeeTemplateDup: new FormControl(data.FeeTemplate),
          Colleges: new FormControl(this.cgValue, [Validators.required]),
          feetempArray: new FormArray([]),
        });
 
      } else {
        //this.umsService.openSnackbar(res.message);
      }
    });
  }
 
 
  deletedata(e, k) {
    if (e === 'true') {
      this.list = false;
      this.prepopulationForDelete(k);
    } else {
      this.list = true;
    }
  }
 
  prepopulationForDelete(id) {
    const payload = {};
    this.getCourseData(id.Faculty);
    payload['TemMappingId'] = id.TemMappingId;
    this.TemMappingIddd = id.TemMappingId;
    this.getFilterCourse(id.Course)
       this.umsService.getFeeTempletMapping(payload).subscribe((res) => {
        this.collegedel = res.data[0].Colleges
        
        if(this.SelectAllActive == true){
          this.cgValue = id.Colleges.split(',');
          this.commaSeparatedColleges = id.Colleges
        }
        else if(this.SelectAllActive == false){
          this.cgValue = res.data[0].Colleges;
          this.commaSeparatedColleges = res.data[0].Colleges;
        }
    
        let data = res.data[0];
      if (res.data[0].Branch != ' ') {
        this.showBranch = true;
        this.getExamStreamData(data.Course);
      } else {
        this.showBranch = false;
      }
      if (res.status) {
        this.isreaddelete =true;
        this.editButton = false;
        this.submitButton = false;
        this.deleteButton = true;
        // this.isreaddelete = false;
        this.getFeeTempletData(data.FeeType)
        this.getCourseData(data.Faculty);
        this.getExam(data.Course)
        this.getSem(data)
        this.getFilterCourse(data.Course)
        this.feeMappingForm = this.fb.group({
          Faculty: new FormControl(data.Faculty, [Validators.required]),
          Course: new FormControl(data.Course, [Validators.required]),
          EmId: new FormControl(data.EmId, [Validators.required]),
          Sem: new FormControl(data.Sem),
          Session: new FormControl(data.Session, [Validators.required]),
          Branch: new FormControl(data.Branch),
          CollegeType: new FormControl(data.CollegeType, [Validators.required]),
          FeeType: new FormControl(data.FeeType, [Validators.required]),
          FeeTemplate: new FormControl(data.FeeTemplate, [Validators.required]),
          FeeTemplateDup: new FormControl(data.FeeTemplate),
          Colleges: new FormControl(this.cgValue, [Validators.required]),
          feetempArray: new FormArray([]),
        });
 
      } else {
        //this.umsService.openSnackbar(res.message);
      }
    });
  }
 
  DeletetheRecord() {
    const data = {};
    data['message'] = 'Are You Sure You Want To Delete This Record ?';
    data['title'] = 'Alert';
    data['icon'] = 'fa fa-question';
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.delete(this.feeMappingForm.value);
      } else {
        // this.ngOnInit();
      }
    });
  }
 
 
  delete(id) {
    // let collegeCode = [id.Colleges.join(',')];
    this.spinner.show();
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
        Faculty: id.Faculty,
        Course: id.Course,
        EmId: id.EmId,
        Sem: id.Sem,
        Session: id.Session,
        Branch: id.Branch,
        FeeType: id.FeeType,
        CollegeType: id.CollegeType,
        FeeTemplate: id.FeeTemplateDup,
        Colleges: this.collegedel,
        TemMappingId: this.TemMappingIddd
      },
    };
    this.httpClient.delete(this.APIService + '/fees/templatemapping', options)
      .subscribe((s) => {
        this.spinner.hide();
        // this.spinner.hide();
        let cc = [];
        cc.push(s);
        let data = {}
        data['message'] = cc[0].message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.dialogRef2.close();
        });
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
        // this.umsService.openSnackbar(ERROR.error.message);
 
      });
 
  }
 
 
  fetchFeeType() {
    const payload = {};
    payload['CdType'] = 'FT';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.feeList = res.data;
        this.filteredfeeList = this.feeList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      // this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }
 
 
  getFeeTempletData(FType) {
    this.FeeTempletList = [];
    this.filteredFeeTempletList = []
    this.spinner.show();
    const payload = {};
    // payload['PageSize'] = this.pageSize;
    // payload['PageNumber'] = this.currentPage;
    payload['FeeType'] = FType;
    this.umsService.getFeeTemplet(payload).subscribe(res => {
      if(res.status){
        this.spinner.hide();
        const ExamTemplate = res.data.filter(item => item.EmId == this.EmId);
        this.FeeTempletList = ExamTemplate;
        // this.filteredFeeTempletList = this.FeeTempletList.slice();
        this.filteredFeeTempletList = this.getUniqueItems(this.FeeTempletList);
        this.filteredFeeTempletList2 = this.filteredFeeTempletList.slice();
      }
      else{
        this.spinner.hide();
        this.FeeTempletList = []
      }
    });
  }
 
  getUniqueItems(items: any[]): any[] {
    const uniqueItems = [];
    const uniqueMap = new Map();
 
    for (const item of items) {
      const key = item.TemplateCode + item.TemplateName;
      if (!uniqueMap.has(key)) {
        uniqueMap.set(key, true);
        uniqueItems.push(item);
      }
    }
    return uniqueItems;
  }
 
 
 
  getClg() {
    const payload = {};
    this.umsService.getCollege(payload).subscribe(res => {
      this.spinner.hide();
      this.collegeList = res.data;
      this.filteredcgList = this.collegeList.slice();
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.collegeList = [];
      //this.spinner.hide();
      // let  data = {};
      // data['message'] = ERROR.error.message;
      // data['title'] = 'Information';
      // data['icon'] = 'fas fa-box-open';
      // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      // this.umsService.openSnackbar(ERROR.error.message);
    })
  }
 
  getFilterCourse(coCode) {
    if(this.userPermission[0].CgUi == 'C'){
      this.UserCollege= this.userPermission[0].CgId;
    }
    else{
      this.UserCollege = ''
    }
    const payload = {};
    payload['CoCgCoCode'] = coCode
    payload['CgCode'] = this.UserCollege
    this.umsService.fetchIntakeFilterForCollege(payload).subscribe(res => {
      this.spinner.hide();
      this.CourseWisecollegeList = res.data;
      this.filteredCourseWisecollegeList = this.CourseWisecollegeList.slice();
      this.collegeListData = true;
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CourseWisecollegeList = [];
      //this.spinner.hide();
      // let  data = {};
      // data['message'] = ERROR.error.message;
      // data['title'] = 'Information';
      // data['icon'] = 'fas fa-box-open';
      // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      // this.umsService.openSnackbar(ERROR.error.message);
    })
  }
  selectAllColleges() {
    
    if (this.isAllCollegesSelected()) {
      // Deselect all colleges
      this.selectedColleges = [];
      this.feeMappingForm.controls['Colleges'].setValue([]); // Reset the selected values
    } else {
      // Select all colleges
      
      this.selectedColleges = this.filteredCourseWisecollegeList.map(item => item.CoCgCgCode);
      
      this.feeMappingForm.controls['Colleges'].setValue([...this.selectedColleges, 'selectAll']); // Add all colleges and "Select All" as the value
    }
    this.updateCommaSeparatedColleges(); // Update the comma-separated string
  }
  
  // Updates `commaSeparatedColleges` based on selected options
  onCollegeSelectionChange(event: any) {
    const selectedValues = event.value;
    this.commaSeparatedColleges = selectedValues
    if (selectedValues.includes('selectAll') && selectedValues.length > 1) {
      // If 'Select All' is selected along with other options, deselect 'Select All'
      this.selectedColleges = selectedValues.filter(value => value !== 'selectAll');
      this.feeMappingForm.controls['Colleges'].setValue(this.selectedColleges);
    } else {
      // Otherwise, update the selected colleges normally
      this.selectedColleges = selectedValues;
    }
  
    this.updateCommaSeparatedColleges(); // Update the comma-separated string
  }
  
  // Helper function to update `commaSeparatedColleges`
  updateCommaSeparatedColleges() {

    if (Array.isArray(this.selectedColleges) && this.selectedColleges.length > 0) {
        this.commaSeparatedColleges = this.selectedColleges.join(',');
    } else {
        this.commaSeparatedColleges = this.selectedColleges || ''; // Fallback if there's a single value or undefined
    }
  }
  
  // Check if all colleges are selected
  isAllCollegesSelected(): boolean {
    return (
      this.filteredCourseWisecollegeList.length > 0 &&
      this.selectedColleges.length === this.filteredCourseWisecollegeList.length
    );
  }
}